import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider";

const routePermissions = [
  {
    pattern: /^\/$/,
    roles: ["super_admin", "bunk_incharge"],
  },
  {
    pattern: /^\/bunk$/,
    roles: ["super_admin"],
  },
  {
    pattern: /^\/bunk\/add$/,
    roles: ["super_admin"],
  },
  {
    pattern: /^\/bunk\/edit\/[^/]+$/,
    roles: ["super_admin"],
  },
  {
    pattern: /^\/bunk\/view$/,
    roles: ["super_admin"],
  },
  {
    pattern: /^\/bunkdetail$/,
    roles: ["bunk_incharge"],
  },
  {
    pattern: /^\/camera$/,
    roles: ["super_admin"],
  },
  {
    pattern: /^\/users$/,
    roles: ["super_admin", "bunk_incharge"],
  },
  {
    pattern: /^\/vehicle$/,
    roles: ["super_admin", "bunk_incharge"],
  },
  {
    pattern: /^\/vehicle\/detail$/,
    roles: ["super_admin", "bunk_incharge"],
  },
];



const RequireAuth = () => {
  const location = useLocation();
  /*const { user } = useAuth();*/
   const role = localStorage.getItem("roleKey");
   const isAuthenticated = localStorage.getItem('auth_token');

   if(!isAuthenticated) {
      return <Navigate to="/login" replace />;
   }

  const currentPath = location.pathname;

  // 🔐 Role-based route validation
  const matchedRule = routePermissions.find(rule =>
    rule.pattern.test(currentPath)
  );

  if (matchedRule && !matchedRule.roles.includes(role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  /*if (matchedRule && !matchedRule.roles.includes(role)) {
    return <Navigate to="/" replace />;
  }*/

  return <Outlet />;
};

export default RequireAuth;
